onReady(($) => {
    const mainMenuWidgetBlocks = Array.from(document.querySelectorAll('#footerMenu > .widgetBlock'))
    for (const widgetBlock of mainMenuWidgetBlocks) {
        const mainMenuItem = widgetBlock.querySelector('a.mainMenuItem')
        mainMenuItem.addEventListener('click', () => {
            if ($(window)
                .width() > 991) {
                return
            }
            mainMenuItem.classList.toggle('toggle')
            $(widgetBlock.querySelector('.submenu'))
                .slideToggle()
        })
    }
    jQuery('.newsletter-btn')
        .on('click', () => {
            if (jQuery('input.newsletterEmail')
                .hasClass('valid') && jQuery('#GDPR_email_opt_in__c')
                .hasClass('valid')) {
                jQuery('#socialmedia')
                    .addClass('removePadding');
            }
        });

    const menuItem = $('#footerBottom .menu-item')
    menuItem.on('click', () => {
        menuItem.toggleClass('show')
    })
});
